export const SIGNS = [
  {
    guid: 'beran',
    name: 'Beran',
    date: '21.3. - 20.4.',
    background: {
      x: 0,
      y: -38
    }
  },
  {
    guid: 'byk',
    name: 'Býk',
    date: '21.4. - 21.5.',
    background: {
      x: -60,
      y: -38
    }
  },
  {
    guid: 'blizenci',
    name: 'Blíženci',
    date: '22.5. - 21.6.',
    background: {
      x: -120,
      y: -38
    }
  },
  {
    guid: 'rak',
    name: 'Rak',
    date: '22.6. - 22.7.',
    background: {
      x: -180,
      y: -38
    }
  },
  {
    guid: 'lev',
    name: 'Lev',
    date: '23.7. - 22.8.',
    background: {
      x: -240,
      y: -38
    }
  },
  {
    guid: 'panna',
    name: 'Panna',
    date: '23.8. - 22.9.',
    background: {
      x: -300,
      y: -38
    }
  },
  {
    guid: 'vahy',
    name: 'Váhy',
    date: '23.9. - 23.10.',
    background: {
      x: 0,
      y: -95
    }
  },
  {
    guid: 'stir',
    name: 'Štír',
    date: '24.10. - 22.11.',
    background: {
      x: -60,
      y: -95
    }
  },
  {
    guid: 'strelec',
    name: 'Střelec',
    date: '23.11. - 21.12.',
    background: {
      x: -120,
      y: -95
    }
  },
  {
    guid: 'kozoroh',
    name: 'Kozoroh',
    date: '22.12. - 20.1.',
    background: {
      x: -180,
      y: -95
    }
  },
  {
    guid: 'vodnar',
    name: 'Vodnář',
    date: '21.1. - 20.2.',
    background: {
      x: -240,
      y: -95
    }
  },
  {
    guid: 'ryby',
    name: 'Ryby',
    date: '21.2. - 20.3.',
    background: {
      x: -300,
      y: -95
    }
  }
]
